import React from 'react';
import { Helmet } from 'react-helmet-async';
const BaseMeta = _ref => {
  let {
    title,
    canonicalUrl,
    description
  } = _ref;
  return /*#__PURE__*/React.createElement(Helmet, {
    prioritizeSeoTags: true
  }, title ? /*#__PURE__*/React.createElement("title", null, title) : null, canonicalUrl ? /*#__PURE__*/React.createElement("link", {
    rel: "canonical",
    href: canonicalUrl
  }) : null, description ? /*#__PURE__*/React.createElement("meta", {
    name: "description",
    content: description
  }) : null);
};
export default BaseMeta;